import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import CloseIcon from '@/assets/svg/close-icon';

import CreateAccount from './create-account';

interface CreateAccountModalProps {
  open: boolean;
  onClose: () => void;
  customTrialData?: {
    custom: number | null;
    trialPageId: number | null;
  };
  daysTrial?: number;
  isDisabledButton?: boolean;
  formId?: string;
}

export function CreateAccountModal({ open, onClose, customTrialData, daysTrial, isDisabledButton, formId }: CreateAccountModalProps) {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as='div' className='relative z-50' onClose={onClose}>
        <Transition.Child as={Fragment} enter='ease-out duration-200' enterFrom='opacity-0' enterTo='opacity-100' leave='ease-in duration-150' leaveFrom='opacity-100' leaveTo='opacity-0'>
          <div className='fixed inset-0 bg-black/70 backdrop-blur-sm' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4'>
            <Transition.Child as={Fragment} enter='ease-out duration-200' enterFrom='opacity-0 scale-95' enterTo='opacity-100 scale-100' leave='ease-in duration-150' leaveFrom='opacity-100 scale-100' leaveTo='opacity-0 scale-95'>
              <Dialog.Panel className='relative w-full max-w-md rounded-xl border border-[#93FF18]/30 bg-[#0B0E12] p-2 shadow-2xl md:p-3'>
                <button type='button' onClick={onClose} className='absolute end-3 top-3 z-10 flex size-7 items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/10 hover:text-white' aria-label='Fechar'>
                  <CloseIcon />
                </button>
                <CreateAccount daysTrial={daysTrial} customTrialData={customTrialData} isDisabledButton={isDisabledButton} formId={formId} compact />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
